<div>  
  <!-- TODO: finish implementing modern table as it is used in question-group-card -->
  <!-- Still needs all of the input parameters to be defined/ updated and any functions or output emit called to be defined -->
<app-modern-table
  [columnOrdering]="columnOrdering"
  [subGroup]="subGroup"
  [deleted]="deleted"
  [inspectMode]="inspectMode"
  [formGroup]="formGroup"
  [groupId]="groupId"
  [readonly]="readOnlyTable()"
  [readonlyGlobal]="readonly"
  [hideClearOverRideQuestionIcon]="hideClearOverRideQuestionIcon"
  [debugMode]="debugMode"
  [taxReturnId]="taxReturnId"
  [isVisible]="isVisible"
  (loadTrace)="loadTrace.emit($event)"
  (selectRow)="selectRow($event)"
  (refreshTaxReturn)="refreshTaxReturn.emit(true)"
  (addNewRow)="newRow()"
  (toggleFullScreen)="toggleFullScreen.emit($event)"
  (handleSaveTable)="handleSaveTable.emit($event)"
  [sideOpen]="sideOpen"
  [isFullScreenMode]="isFullScreenMode"
  [inputQuestionId]="inputQuestionId"
  [inspectMode]="inspectMode"
  ></app-modern-table>
</div>
